import React from 'react';
import { Route } from 'react-router-dom';
import UserActionSubscriptions from './userActionSubscriptions';

export default (
  <Route path="/homepage/assinaturas/:actionId?" component={UserActionSubscriptions} />
)
